import * as _ from "../../../util/lodash";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import "../../../util/velocity";
import { VelocityTransitionGroup, VelocityComponent } from 'velocity-react';

function OnMountChange(props) {
  var _classnames;

  return /*#__PURE__*/React.createElement(VelocityTransitionGroup, {
    enter: props.onMountAnimation,
    leave: props.onUnmountAnimation,
    className: classnames((_classnames = {}, _classnames[props.className] = props.className, _classnames), 'transition-group'),
    component: "div",
    runOnMount: props.runOnMount
  }, props.children);
}

OnMountChange.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  onMountAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onUnmountAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  runOnMount: PropTypes.bool
};
OnMountChange.defaultProps = {
  children: null,
  className: undefined,
  onMountAnimation: {
    animation: 'fadeIn'
  },
  onUnmountAnimation: {
    animation: 'fadeOut'
  },
  runOnMount: false
};

function OnTransition(props) {
  return /*#__PURE__*/React.createElement(VelocityComponent, {
    animation: !!props.transitionCondition ? props.truthyAnimation : props.falsyAnimation,
    runOnMount: props.runOnMount,
    complete: props.onComplete,
    duration: props.duration,
    delay: props.delay
  }, props.children);
}

OnTransition.propTypes = {
  children: PropTypes.node.isRequired,
  falsyAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  runOnMount: PropTypes.bool,
  truthyAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  transitionCondition: PropTypes.bool.isRequired,
  onComplete: PropTypes.func,
  duration: PropTypes.number,
  delay: PropTypes.number
};
OnTransition.defaultProps = {
  falsyAnimation: 'fadeOut',
  runOnMount: false,
  truthyAnimation: 'fadeIn',
  onComplete: _.noop,
  duration: undefined,
  delay: undefined
};
var Animate = {
  OnMountChange: OnMountChange,
  OnTransition: OnTransition
};
export default Animate;
//# sourceMappingURL=index.js.map